import { getAdjustments, handleError, cancelAdjustment, approveAdjusment, } from '@/modules/occurrences/_api';
import Adjustment from '@/models/Adjustment';
import format from '@/plugins/baseFormat';
import dayjs from 'dayjs';

const mapStatus = new Map([
  ['APPROVED', 'Finalizado',],
  ['CANCELED', 'Cancelado',],
  ['PENDING', 'Aguardando',],
],);
const mapResponsible = new Map([
  ['FRANCHISOR', 'Franqueadora',],
  ['FRANCHISE', 'Franquia',],
],);

const mapType = new Map([
  ['ORDER_ERROR', 'Erro em pedido',],
  ['PRODUCT_DISCOUNT', 'Desconto em produto',],
  ['PROMOTIONAL_DELIVERY', 'Entrega promocional',],
  ['EXEMPTIONS', 'Isenção',],
  ['ADHESION_FEE', 'Taxa de adesão',],
  ['OTHER_CHARGES', 'Outra cobrança',],
  ['OTHER_DISCOUNTS', 'Outro desconto',],
],);

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    occurrences: [],
    filtered: [],
    pageCount: 0,
    totalCount: 0,
    params: {},
    loading: false,
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.occurrences,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    filtered: (state,) => state.filtered,
    params: (state,) => state.params,
    loading: (state,) => state.loading,
  },
  // -----------------------------------------------------------------
  mutations: {
    setOccurrences: (state, occurrences,) => (state.occurrences = occurrences),
    setStatus: (state, status,) => (state.status = status),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
    setFiltered: (state, filtered,) => (state.filtered = filtered),
    setParams: (state, params,) => (state.params = params),
    setLoading: (state, loading,) => (state.loading = loading),
  },
  // -----------------------------------------------------------------
  actions: {
    get: ({ commit,}, {textSearch, competenceDates, status, type, page, 
      activeLoading, },) => {
      commit('occurrences/setOccurrences', [], { root: true, },);
      commit('occurrences/setParams', {textSearch, competenceDates, status, type, }, { root: true, },);

      if (activeLoading) {
        commit('occurrences/setLoading', true, { root: true, },);
      }
      return getAdjustments({textSearch, competenceDates, status, type, page, 
      },).then(
        (response,) => {
          const items = response.data.data;         
          const count = response.data.count;
          const total = response.data.total;
          const adjustments = items.map((adjustment,) => {
            let compDate = adjustment.competenceDate;
            return new Adjustment({
              ...adjustment,
              value: format.money(Math.abs(adjustment.amount / 100,),),
              statusText: mapStatus.get(adjustment.status,),
              responsibleText: mapResponsible.get(adjustment.responsible,),
              typeText: mapType.get(adjustment.type,),
              code: `#${adjustment.code}`,
              companyName: adjustment.company.name,
              createdAt: dayjs(adjustment.createdAt,).format('DD/MM/YYYY',), 
              city: adjustment.city.name + ' - ' + adjustment.city.state.acronym,
              cityName: adjustment.city.name,
              description: adjustment.description,
              userName: adjustment.createdBy.name,
              companyId: adjustment.company.id,
              competenceDate: (compDate) ?
                dayjs().month(compDate.month - 1,).format('MMMM',).charAt(0,).toUpperCase() + 
                dayjs().month(compDate.month - 1,).format('MMMM',).slice(1,) + '/' + 
                compDate.year : ' ',
            },);
          },);
          commit('occurrences/setLoading', false, { root: true, },);
          commit('occurrences/setOccurrences', adjustments, { root: true, },);
          commit('occurrences/setPageCount', Math.ceil(total / count,), { root: true, },);
          commit('occurrences/setTotalCount', total, { root: true, },);
          commit('occurrences/setFiltered', adjustments, { root: true, },);

          return adjustments;
        },
        (error,) => {
          return handleError(error,);
        },
      );
    },
    cancel: ({getters, }, adjustment, ) => {
      cancelAdjustment(adjustment.id, adjustment.data,).then(
        (response,) => {
          const { all, }  = getters;
          const { data: responseAdjustment, } = response;
          
          const [adjustment,] = all.filter(
            (adjustment,) => adjustment.id === responseAdjustment._id,
          );
          adjustment.status = responseAdjustment.status;
          adjustment.statusText = mapStatus.get(responseAdjustment.status,);

          adjustment.canceledAt = responseAdjustment.canceledAt;
          adjustment.cancellationReason = responseAdjustment.cancellationReason;

          const canceledInfo = responseAdjustment.canceledBy;
          adjustment.canceledBy = {
            user: canceledInfo.user,
          };
        },
        (error,) => {
          return handleError(error,);
        },
      );
    },
    approve: ({getters, }, adjustment, ) => {
      approveAdjusment(adjustment.id,).then(
        (response,) => {
          const { all, }  = getters;
          const { data: responseAdjustment, } = response;
          
          const [adjustment,] = all.filter(
            (adjustment,) => adjustment.id === responseAdjustment._id,
          );
          adjustment.status = responseAdjustment.status;
          adjustment.statusText = mapStatus.get(responseAdjustment.status,);
          adjustment.billingDate = { 
            month: responseAdjustment.billingDate.month, 
            year: responseAdjustment.billingDate.year, 
          };
          adjustment.approvedAt = responseAdjustment.approvedAt;
          const approvedInfo = responseAdjustment.approvedBy;
          adjustment.approvedBy = {
            user: approvedInfo.user,
          };
        },
        (error,) => {
          return handleError(error,);
        },
      );
    },
  },
  // -----------------------------------------------------------------
};
